var _polygon, _polygon2, _polygon3, _path, _polygon4, _polygon5, _polygon6, _polygon7, _polygon8, _polygon9, _polygon10, _polygon11, _path2, _polygon12, _polygon13, _polygon14, _path3, _rect, _rect2, _rect3, _path4, _polygon15, _polygon16;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgOrders(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 512.005 512.005",
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#D4E4AC"
    },
    points: "336.981,87.836 280.957,87.836 256.951,103.842 232.945,87.836 176.92,87.836 176.92,7.805  336.981,7.805 "
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 401.005,
    y: 247.901,
    style: {
      fill: "#E2804F"
    },
    width: 40.016,
    height: 88.035
  }), /*#__PURE__*/React.createElement("rect", {
    x: 72.885,
    y: 247.901,
    style: {
      fill: "#E2804F"
    },
    width: 40.016,
    height: 88.035
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 352.986,
    y: 367.948,
    style: {
      fill: "#F2BF7E"
    },
    width: 144.806,
    height: 144.057
  }), /*#__PURE__*/React.createElement("rect", {
    x: 16.858,
    y: 367.948,
    style: {
      fill: "#F2BF7E"
    },
    width: 144.806,
    height: 144.057
  }), /*#__PURE__*/React.createElement("rect", {
    x: 216.932,
    y: 135.856,
    style: {
      fill: "#F2BF7E"
    },
    width: 80.031,
    height: 152.06
  })), /*#__PURE__*/React.createElement("polyline", {
    style: {
      fill: "#E2804F"
    },
    points: "160.914,512 160.914,319.926 352.988,319.926 352.988,512 "
  }), _polygon || (_polygon = /*#__PURE__*/React.createElement("polygon", {
    points: "360.793,512 345.182,512 345.182,327.731 168.719,327.731 168.719,512 153.108,512 153.108,312.121  360.793,312.121 "
  })), _polygon2 || (_polygon2 = /*#__PURE__*/React.createElement("polygon", {
    points: "311.161,512 295.55,512 295.55,386.072 319.487,386.072 319.487,401.683 311.161,401.683 "
  })), _polygon3 || (_polygon3 = /*#__PURE__*/React.createElement("polygon", {
    points: "216.455,512 200.844,512 200.844,401.683 192.518,401.683 192.518,386.072 216.455,386.072 "
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M304.772,295.719H209.13V128.05h95.642V295.719z M224.74,280.108h64.42V143.661h-64.42L224.74,280.108L224.74,280.108z"
  })), _polygon4 || (_polygon4 = /*#__PURE__*/React.createElement("polygon", {
    points: "503.695,512 488.084,512 488.084,375.665 368.401,375.665 368.401,360.054 503.695,360.054 "
  })), _polygon5 || (_polygon5 = /*#__PURE__*/React.createElement("polygon", {
    points: "503.695,512 488.084,512 488.084,375.665 368.401,375.665 368.401,360.054 503.695,360.054 "
  })), _polygon6 || (_polygon6 = /*#__PURE__*/React.createElement("polygon", {
    points: "463.107,512 447.496,512 447.496,417.294 472.473,417.294 472.473,432.905 463.107,432.905 "
  })), _polygon7 || (_polygon7 = /*#__PURE__*/React.createElement("polygon", {
    points: "392.337,512 376.727,512 376.727,432.905 368.401,432.905 368.401,417.294 392.337,417.294 "
  })), _polygon8 || (_polygon8 = /*#__PURE__*/React.createElement("polygon", {
    points: "503.695,512 488.084,512 488.084,375.665 368.401,375.665 368.401,360.054 503.695,360.054 "
  })), _polygon9 || (_polygon9 = /*#__PURE__*/React.createElement("polygon", {
    points: "503.695,512 488.084,512 488.084,375.665 368.401,375.665 368.401,360.054 503.695,360.054 "
  })), _polygon10 || (_polygon10 = /*#__PURE__*/React.createElement("polygon", {
    points: "463.107,512 447.496,512 447.496,417.294 472.473,417.294 472.473,432.905 463.107,432.905 "
  })), _polygon11 || (_polygon11 = /*#__PURE__*/React.createElement("polygon", {
    points: "392.337,512 376.727,512 376.727,432.905 368.401,432.905 368.401,417.294 392.337,417.294 "
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M448.827,343.738h-55.626V240.092h55.626V343.738z M408.812,328.127h24.404v-72.424h-24.404V328.127z"
  })), _polygon12 || (_polygon12 = /*#__PURE__*/React.createElement("polygon", {
    points: "23.921,512 8.31,512 8.31,360.054 143.604,360.054 143.604,375.665 23.921,375.665 "
  })), _polygon13 || (_polygon13 = /*#__PURE__*/React.createElement("polygon", {
    points: "63.469,512 47.858,512 47.858,432.905 40.573,432.905 40.573,417.294 63.469,417.294 "
  })), _polygon14 || (_polygon14 = /*#__PURE__*/React.createElement("polygon", {
    points: "136.319,512 120.708,512 120.708,417.294 143.604,417.294 143.604,432.905 136.319,432.905 "
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M120.701,343.738H65.074V240.092h55.627V343.738z M80.684,328.127h24.405v-72.424H80.684V328.127z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 249.756,
    y: 337.153,
    style: {
      fill: "#FFFFFF"
    },
    width: 15.611,
    height: 15.611
  }), /*#__PURE__*/React.createElement("rect", {
    x: 249.756,
    y: 360.049,
    style: {
      fill: "#FFFFFF"
    },
    width: 15.611,
    height: 86.38
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 216.453,
    y: 41.593,
    width: 15.611,
    height: 15.611
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 249.756,
    y: 41.593,
    width: 15.611,
    height: 15.611
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 280.978,
    y: 41.593,
    width: 15.611,
    height: 15.611
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M360.075,41.593h-15.288V0H169.115v41.593h-16.144v15.611h16.144v38.439h61.467l26.369,17.583l26.37-17.583h61.467V57.203 h15.288V41.593H360.075z M329.176,80.031h-50.583L256.95,94.46l-21.641-14.43h-50.583v-64.42h144.45V80.031z"
  })), _polygon15 || (_polygon15 = /*#__PURE__*/React.createElement("polygon", {
    points: "143.604,57.203 143.604,41.593 88.446,41.593 88.446,190.161 78.399,180.112 67.36,191.152 95.849,220.68  125.377,191.151 115.378,180.113 104.057,191.435 104.057,57.203 "
  })), _polygon16 || (_polygon16 = /*#__PURE__*/React.createElement("polygon", {
    points: "434.461,182.194 423.559,193.097 423.559,41.593 368.401,41.593 368.401,57.203 407.948,57.203 407.948,192.662  397.482,182.193 386.442,193.233 415.971,222.762 445.5,193.232 "
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgOrders);
export default __webpack_public_path__ + "static/media/Orders.c447196f045b689f5df8b1f82a6b3a1d.svg";
export { ForwardRef as ReactComponent };